import React from 'react';
import TextArea from "./TextArea";

class BrandForm extends React.Component {
  constructor(props) {
    super(props);
    
    const nameCN = props.brand.nameCN ? props.brand.nameCN : '';
    const desc = props.brand.descriptions ? props.brand.descriptions.join('\n') : '';
    this.state = {nameCN, desc};
  }

  render() {
    return (
      <div>
        <form className='form'>
          <div className="form-group">
            <input className="form-control mt-3"
              type="text"
              placeholder='修改品牌中文名称'
              onChange={ (event) => this.onBrandNameChange(event) }
              value={ this.state.nameCN } />
          </div>
          <div className="mt-3 form-group">
            {/* <MediaUploader uploadImage={this.onUploadBrandImage.bind(this)} /> */ }
          </div>
          <div className="mt-3 form-group">
            <TextArea
              placeholder="添加品牌介绍"
              defaultText={ this.state.desc }
              onTextChange={ (text) => this.onDescriptionChange(text) } />
          </div>
          <div className="form-group mt-3 float-right">
            <button className="btn btn-danger" type="cancel" onClick={ (event) => { this.onCancel(event) } }>取消</button>
            <button className="btn btn-info ml-3" onClick={ (event) => this.onSubmit(event) } type='submit'>保存</button>
          </div>
        </form>
      </div>
    );
  }

  onCancel(event) {
    event.preventDefault();
    this.props.onCancel();
  }

  onSubmit(event) {
    event.preventDefault();
    this.props.newBrand({
      nameCN: this.state.nameCN,
      desc: this.state.desc
    });
  }

  onDescriptionChange(text) {
    this.setState({ desc: text })
  }

  onUploadBrandImage() {

  }

  onBrandNameChange(event) {
    this.setState({ nameCN: event.target.value })
  }
}

export default BrandForm;